import { CompVerticalMenuCore } from '../core/vertical-menu/comp'

export const CompVerticalMenu = CompVerticalMenuCore
